"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UnlockCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11 9.99V11h-1V9.98A1.98 1.98 0 0 1 11.98 8h.04A1.98 1.98 0 0 1 14 9.98V11h-1V9.99a.99.99 0 0 0-.99-.99h-.02a.99.99 0 0 0-.99.99m2 .51v.5h1v-.5z"/><path fill="inherit" d="M10 10h1v2h-1zm-1 5a1 1 0 0 0 .99 1h4.02c.55 0 .99-.44.99-1v-2a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1z"/><rect width="1" height="1" x="13" y="10" fill="inherit" rx=".5"/></g></svg>`
}, props));
UnlockCircleIcon.displayName = 'UnlockCircleIcon';
var _default = exports.default = UnlockCircleIcon;